<template>
  <div class="mainbody" style="min-height: 40vw;">
    <div class="containerDiv"> 
      <div class="whiteBg"  > 
        <div class="txtMd2" v-scroll-animate="'fade-in'" > 
          <div v-html="brief.content"></div>
        
        </div>
      </div>
       <div class="modules3Container"> 
        <div class="modules3Div" v-scroll-animate="'fly-in-left5'"> 
          <div class="modules3rowDiv" >
         
              <div class="modules3Item modules3Item1" v-for="(item,index) in segmentsList[0].slice(0,5)" :key="index"
                                     @mouseover="indexNum = index"
                                    @mouseleave="indexNum = null"
                                    @click="goA(index+1,item.id)"
                                  :class="(indexNum == index)?'activeYwbkItem2':''"  >
                <ul>
                  <li>
                    <img :src="urlBase+item.icon.split('|')[1]" />
                  </li>
                  <li class="titleModule3item">
                    <a  @click="goA(index+1,item.id)">{{ item.names }} </a>
                  </li>
                </ul>
              </div>
           
          </div>

          <div class="goDetailDiv"> <a href="/detailPage2" target="_blank">(港贸公司)详情>></a> </div>

        </div>
      </div>


      <!-- 港产模块 -->
      
 
      <div class="modules3Container"> 
        <div class="modules3Div" v-scroll-animate="'fly-in-left5'"> 
          <div class="modules3rowDiv" >
            <div class="modules3Item modules3Item1"  @mouseover="indexNum1 = index"
                                  @mouseleave="indexNum1 = null"
                                  @click="goA1(index,item.id)"
                                :class="(indexNum1 == index)?'activeYwbkItem2':''"
                                v-for="(item,index) in segmentsList[1]" :key="index">
              <ul>
                <li>
                  <img :src="urlBase+item.icon.split('|')[1]" />
                </li>
                <li class="titleModule3item">
                  <a >{{ item.names }} </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="goDetailDiv"> <a href="/detailPageGangchan" target="_blank">(港产公司)详情>></a> </div>

        </div>
      </div>
    </div>
   </div>
</template>

<script>
// import Modules3 from '@/components/gk/Modules3.vue'
import API from '@/api/bsInfo'

export default {
 components: {
 },
 data() {
   return {
   indexNum:null,
   indexNum1:null,
   urlBase: process.env.VUE_APP_BASE_API,
    brief:{},
    segmentsList:[],
    
     
   }
 },
 props: {
   
 },
 mounted() {
     this.zhongoubanlieData();
   },
 methods: {
  //获取页面数据
  async zhongoubanlieData() {
      try {
        let objParams={
          catId:'7c8b7951515f470bb087c29c2272eafb'
        }
        const res = await API.zhongoubanlieData(objParams)
        this.$nextTick(()=>{
          this.zhongouData = res.data
          this.brief=res.data.brief
          this.segmentsList=res.data.segmentsList
          
          console.log('获取成功', res.data.resultData)
        })
       
      } catch (error) {
        console.error('获取失败', error)
      }
    },

  goA(indexNum,id){
    
    // window.location.href='/detailPage2?index='+indexNum+'&id='+id
    this.$router.push({
          path: '/detailPage2',
          query: {                     
            index: indexNum,
            id:id
          }
        })
  },
  goA1(indexNum,id){
    this.$router.push({
          path: '/detailPageGangchan',
          query: {                     
            index: indexNum,
            id:id
          }
        })
  },
 },
}
</script>

<style lang="scss" scoped>

 .mainbody{
   width: 100%
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    
 }
 .containerDiv{
 width: 100%;
   // background: #dde8f4;
   // margin-block: 100px;
  //  background:url('../../assets/img3/gaikuang1/chanyepng.png');
//  background-size: 100% 100%;
  background:url('../../assets/img3/yewubankuai1/5.png');
  background-size: cover;
  background-position: center;
 @media screen and (max-width: 768px) {
   background-size: auto 100%;
 }
 }

 .whiteBg{
   width: 100%;
   margin:0 auto;
  //  margin-bottom: 5rem;
   padding:0;
   background:url('../../assets/img3/yewubankuai1/1.png');
    background-size: cover;
  //  background:linear-gradient(to bottom, rgba(252, 253, 253, 0), rgb(251, 252, 252,0.8))
  .txtMd2{
    width: 62%;
    // padding:8vh 0;
    padding-top: 3rem;
    padding-bottom: 3rem;

    margin-left:5%;
    text-indent:2rem;
    color: #333333;
    text-align: justify;
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-left:0;
      line-height: 2rem;
      padding: 3rem;

    }
     /* 重置所有子元素 */
     & * {
      all: initial;
      font-family: inherit;
      font-size: inherit;
      color: inherit;

     
      text-indent:2rem;
      text-align: justify;
      line-height: 2rem;
    }
    
  }
  .txtMd2 ::v-deep(*) {
    font-size: 1.0rem !important;
    line-height: 2rem !important;
  }
  .txtMd2 ::v-deep(p) {
     width: 100%;
     display: block;

    //  background: red;
  }
 } 
 .modules3Container{
  // width: 100%;
  // background:url('../../assets/ywbkNew/1/7.png');
  // background-size: cover;
  // min-height: 50vw;

  position: relative;
  width: 100%;
  // padding-bottom: 26.25%; /* 16:9 比例 (9/16=0.5625) */
  // background:#015293;

  // background:url('../../assets/img3/yewubankuai1/5.png');
  // background-size: cover;
  // background-position: center;

 }
 .modules3Div{
   width: 90%;
   margin:0 auto;
   padding:2rem 0;
 }
 .modules3Item{
  background: none;
  border: 1px solid #a3c9fa;
  color: #ffffff;
  padding: 4rem 0;
  li{
   img{
    filter: brightness(0) invert(1); /* 将图片变为白色 */
   }
   a{
      color:white;
    }
   }
 }
 .modules3rowDiv{
  padding-top:3rem;
 }
 .activeYwbkItem2{
  // background-color: rgba(249, 249, 251, 0.5);  
  background: #ffffff;
   color: #333333;
   .titleModule3item{
    font-size: 1.2rem;
    font-weight: bold;
   
   }
   li{
   img{
    filter: brightness(0); /* 将图片变为黑色 */
   }
   a{
      color: #333333;;
    }
  
   }
 }
 </style>